import * as React from 'react';

export interface IHamburgerProps {
  active: boolean;
  onClick: () => void;
} 

const Hamburger = (props: IHamburgerProps) => {
  return (
    <div className={`hamburgerHolder${props.active ? ' active' : ''}`} onClick={() => props.onClick()}>
      <div className={`hamburger`}>
        <div />
      </div>
      <div className={`hamburgerActive`}>
        <div />
      </div>
      {/* <p style={{ margin: '0', padding: '0 10px' }}>Menu</p> */}
    </div>
  );
};

export default Hamburger;


// WEBPACK FOOTER //
// ./src/components/Header/components/Hamburger/Hamburger.tsx